import {
  SIGN_IN_SUCCESS,
  INSTITUTE_CAMPUS_ID,
  INSTITUTE_DETAILS,
  SET_USER_ROLE,
  SET_USER_ID,
  SET_USER_INFO,
  SET_COUNTRIES_LIST,
  SET_STATES_LIST,
  SET_CITIES_LIST,
  SET_USER_NOTIFICATIONS,
  SET_USER_PERMISSIONS
} from 'modules/Auth/actions'

const initialState = {
  token: null,
  instituteCampusId: '',
  instituteDetails: {},
  userRoleList: [],
  userId: '',
  userData: {},
  listOfCountries: [],
  listOfStates: [],
  listOfCities: [],
  notifications: [],
  permissions: []

}

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        token: action.token,
      }
    case INSTITUTE_CAMPUS_ID:
      return {
        ...state,
        instituteCampusId: action.id,
      }
    case INSTITUTE_DETAILS:
      return {
        ...state,
        instituteDetails: action.data,
      }
    case SET_USER_ROLE:
      return {
        ...state,
        userRoleList: action.list,
      }
    case SET_USER_ID:
      return {
        ...state,
        userId: action.id,
      }
    case SET_USER_INFO:
      return {
        ...state,
        userData: action.data,
      }
    case SET_USER_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.data,
      }

    case SET_COUNTRIES_LIST:
      return {
        ...state,
        listOfCountries: action.data,
      }
    case SET_STATES_LIST:
      return {
        ...state,
        listOfStates: action.data,
      }
    case SET_CITIES_LIST:
      return {
        ...state,
        listOfCities: action.data,
      }
     case SET_USER_PERMISSIONS:
      return {
        ...state,
        permissions: action.data,
      }
    default:
      return state
  }
}
